<h2 mat-dialog-title>{{ procedure.name }}</h2>
<mat-dialog-content class="mat-typography">
  <div class="row">
    <div class="row">
      <div class="col-md-4 col-lg-3"><b>Tipo de serviço:</b></div>
      <div class="col-md-8 col-lg-9">{{ procedure.serviceType }}</div>
    </div>
    <div class="row">
      <div class="col-md-4 col-lg-3"><b>Descrição:</b></div>
      <div class="col-md-8 col-lg-9" [innerHTML]="textLineBreak(procedure.description)"></div>
    </div>
    <div class="row">
      <div class="col-md-4 col-lg-3"><b>Orientações do serviço:</b></div>
      <div class="col-md-8 col-lg-9" [innerHTML]="textLineBreak(procedure.extraDetails)"></div>
    </div>

    <page-alert [message]="getProcedurePaymentText()"></page-alert>

  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div class="toogle">
    <mat-slide-toggle (change)="changeStatus()" [(ngModel)]="active" *ngIf="currentUser.type == 'organization'">Ativo</mat-slide-toggle>
  </div>  
  <button mat-flat-button color="primary" (click)="openProcedureFormEdit()" [mat-dialog-close]="true" cdkFocusInitial>Editar</button>
  <button mat-button color="primary" [mat-dialog-close]="false">Fechar</button>

</mat-dialog-actions>
